// Libraries
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

// Components
import { StyledButton as SStyledButton } from '../../ui/Button/style'
import { WrapFormContent } from '../../pages/StageOne/WrapFormContent'

export const Wrap = styled(motion.div)`
  display: flex;
  flex-direction: column;
  padding-top: 160px;
  align-self: center;
  ${({ theme }) => css`
    ${theme.media.laptopS} {
      padding-top: 140px;
    }
  `}
`;

export const TextOutlined = styled(motion.h1)`
  color: transparent;
  outline-color: #ffe600;
  outline-width: 4px;
  -webkit-text-stroke-color: #ffe600;
  -webkit-text-stroke-width: 4px;
  font-size: 100px;
  line-height: 70px; 
  user-select: none;
  ${({ theme }) => css`
    ${theme.media.desktop} {
      font-size: 80px;
      line-height: 60px;
    }
    ${theme.media.laptopS} {
      font-size: 72px;
      line-height: 60px;
    }
    ${theme.media.tablet} {
      font-size: 64px;
      line-height: 50px;
    }
    ${theme.media.mobileL} {
      text-align: center;
      font-size: 80px;
      line-height: 90px;
      -webkit-text-stroke-width: 3px;
    }
    ${theme.media.mobileM} {
      font-size: 70px;
      line-height: 80px;
    }
  `}
`;

export const Caption = styled.h3`
  color: #ffe600;
  font-size: 48px;
  font-weight: 500;
  font-family: "Avenir Next Regular", sans-serif;
  ${({ theme }) => css`
    ${theme.media.desktop} {
      font-size: 40px;
    }
    ${theme.media.laptopS} {
      font-size: 34px;
    }
    ${theme.media.mobileL} {
      font-size: 32px;
    }
    ${theme.media.mobileM} {
      font-size: 28px;
    }
  `}
`;

export const CaptionFantomMobile = styled(Caption)`
  ${({ theme }) => css`
    ${theme.media.mobileL} {
      display: none;
    }
  `}
`;

interface DescriptionInterface {
  $textAlign?: string;
}

export const Description = styled(motion.p)`
  font-family: "Avenir Next Regular", sans-serif;
  font-size: 24px;
  line-height: 33px;
  color: #ffe600;
  width: 100%;
  ${({ $textAlign: textAlign }: DescriptionInterface) => textAlign && `text-align: ${textAlign};`}
  ${({ theme }) => css`
    ${theme.media.tablet} {
      font-size: 18px;
      line-height: 25px;
    }
  `}
`;

interface TitleInterface {
  $textAlign?: string;
}

export const Title = styled(motion.h2)`
  font-family: "Avenir Next Regular", sans-serif;
  ${({ $textAlign: textAlign }: TitleInterface) => `text-align: ${textAlign};`}
  color: #ffe600;
  font-weight: 500;
  font-size: 64px;
  ${({ theme }) => css`
    ${theme.media.desktop} {
      font-size: 48px;
      line-height: 55px;
    }
    ${theme.media.laptopS} {
      font-size: 36px;
      line-height: initial;
    }
    ${theme.media.tablet} {
      font-size: 36px;
    }
    ${theme.media.mobileL} {
      font-size: 32px;
      line-height: 44px;
    }
    ${theme.media.mobileM} {
      font-size: 24px;
      line-height: 28px;
    }
  `}
`;

export const TitleDesktopFantom = styled(Title)`
  display: none;
  ${({ theme }) => css`
    ${theme.media.mobileL} {
      text-align: center;
      display: block;
      font-weight: 500;
      font-size: 32px;
      line-height: 44px;
    }
  `}
`

export const TitleInitialPage = styled(Title)`
  ${({ theme }) => css`
    ${theme.media.mobileL} {
      display: none;
    }
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;
  ${({ theme }) => css`
    ${theme.media.tablet} {
      width: 95%;
    }
  `}
`;

export const ColumnMargin = styled(Column)`
  row-gap: 20px;
  margin-bottom: 20px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 40px;
  ${({ theme }) => css`
    ${theme.media.laptopS} {
      column-gap: 30px;
    }
    ${theme.media.mobileL} {
      column-gap: 20px;
    }
  `}
`;

export const FakeRow = styled(Row)`
  ${({ theme }) => css`
    ${theme.media.mobileL} {
      flex-direction: column;
    }
  `} 
`

export const Vertical = styled.div`
  display: inline-block;
  height: 142px;
  width: 4px;
  background-color: #ffe600;
  ${({ theme }) => css`
    ${theme.media.desktop} {
      height: 120px;
    }
    ${theme.media.tablet} {
      height: 100px;
    }
    ${theme.media.mobileL} {
      height: 80px;
    }
  `}
`;

export const DirtyButton = styled(SStyledButton)`
  margin: 35px 0 80px 0;
  ${({ theme }) => css`
    ${theme.media.tablet} {
      margin: 25px 0;
    }
    ${theme.media.mobileL} {
      font-size: 22px;
    }
  `}
`;

export const RestrictedByWidth = styled(WrapFormContent)`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  margin: 0 0 50px 0;
  ${({ theme }) => css`
    ${theme.media.tablet} {
      display: none;
    }
  `}
`;

export const RestrictedByWidthMobile = styled(RestrictedByWidth)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 40px 0;
  display: none;
  ${({ theme }) => css`
    ${theme.media.tablet} {
      display: flex;
    }
  `}
`;
